import React from "react";
import { RecurringMemberItemsService } from "./RecurringMemberItemsService";
import { useClient } from "../../common/ClientProvider";
import { useAuth0 } from "@auth0/auth0-react";

interface RecurringMemberItemsServiceProviderProps {
    children: React.ReactNode;
}

export const RecurringMemberItemsServiceContext = React.createContext<
    RecurringMemberItemsService | undefined
>(undefined);

export const RecurringMemberItemsServiceProvider: React.FC<
    RecurringMemberItemsServiceProviderProps
> = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { currentClientId } = useClient();

    const service = React.useMemo(() => {
        return new RecurringMemberItemsService(getAccessTokenSilently, currentClientId);
    }, [getAccessTokenSilently, currentClientId]);

    return (
        <RecurringMemberItemsServiceContext.Provider value={service}>
            {children}
        </RecurringMemberItemsServiceContext.Provider>
    );
};

export const useRecurringMemberItemsService = (): RecurringMemberItemsService => {
    const context = React.useContext(RecurringMemberItemsServiceContext);
    if (context === undefined) {
        throw new Error(
            "useRecurringMemberItemsService must be used within a RecurringMemberItemsServiceProvider"
        );
    }
    return context;
};
